import {
  LayoutGrid,
  FileText,
  Bell,
  Clock,
  Menu,
  ShieldCheck,
  Users,
} from "lucide-react";
import {
  MENU_ITEM_ID,
  getMenuOverflowBadgeCount,
  isBottomNavPage,
} from "../../utils/mobileBottomNav";
import { useNavigation } from "../../context/NavigationContext";
import "./MobileBottomNav.css";

const iconMap = {
  LayoutGrid,
  FileText,
  Bell,
  Clock,
  Menu,
  ShieldCheck,
  Users,
};

function NavBadge({ count }) {
  if (!count || count <= 0) return null;
  return (
    <span className="ess-bottom-nav-badge">
      {count > 99 ? "99+" : count}
    </span>
  );
}

function MobileBottomNav({
  items,
  activeId,
  badges = {},
  sidebarOpen = false,
  onSelect,
  onOpenMenu,
}) {
  const navigation = useNavigation();
  if (!items?.length) return null;

  const menuOverflow = getMenuOverflowBadgeCount(items, badges);
  const menuActive =
    sidebarOpen ||
    (activeId && !isBottomNavPage(activeId, items));

  return (
    <nav
      className="ess-bottom-nav"
      aria-label="التنقل السريع"
    >
      {items.map((item) => {
        const Icon = iconMap[item.icon] || LayoutGrid;
        const isMenu = item.id === MENU_ITEM_ID;
        const isActive = isMenu
          ? menuActive
          : activeId === item.id && !sidebarOpen;

        let badgeCount = 0;
        if (isMenu) {
          badgeCount = menuOverflow;
        } else if (item.badgeKey) {
          badgeCount = badges[item.badgeKey] || 0;
        }

        function handleClick() {
          if (isMenu) {
            onOpenMenu?.();
            return;
          }
          if (navigation?.navigate) navigation.navigate(item.id);
          else onSelect?.(item.id);
        }

        return (
          <button
            key={item.id}
            type="button"
            className={`ess-bottom-nav-item ${isActive ? "is-active" : ""}`}
            onClick={handleClick}
            aria-current={isActive ? "page" : undefined}
            aria-label={
              badgeCount > 0
                ? `${item.label}، ${badgeCount} بانتظارك`
                : item.label
            }
          >
            <span className="ess-bottom-nav-icon-wrap">
              <Icon size={22} strokeWidth={isActive ? 2.25 : 1.75} />
              <NavBadge count={badgeCount} />
            </span>
            <span className="ess-bottom-nav-label">{item.label}</span>
          </button>
        );
      })}
    </nav>
  );
}

export default MobileBottomNav;
